import React from 'react';

const LoadingSpinner = ({ size = 'md', text = 'Laster...' }) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-12 w-12',
    lg: 'h-16 w-16'
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className={`animate-spin rounded-full border-b-2 border-yellow-500 mx-auto ${sizeClasses[size]}`}></div>
        <p className="text-gray-400 mt-4">{text}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;